import { render } from "./LeiloesEmAberto.vue?vue&type=template&id=d8045d0e&scoped=true"
import script from "./LeiloesEmAberto.vue?vue&type=script&lang=js"
export * from "./LeiloesEmAberto.vue?vue&type=script&lang=js"

import "./LeiloesEmAberto.vue?vue&type=style&index=0&id=d8045d0e&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8045d0e"]])

export default __exports__